import moment from 'moment-timezone';

export const formatTimeUTCToDaylightSaving = (date, zone) => {
  try {
    // moment.tz.setDefault(zone);
    const momentDate = moment.tz(date, zone);
    if (momentDate.isDST()) {
      return momentDate.subtract(1, 'hour');
    }
    return momentDate;
  } catch (e) {
    return moment(date);
  }
};

export function getTrainingTime(_data) {
  const { trainingId, timeZoneId } = _data;
  const tz = _data.timeZoneTitle || 'America/Chicago';
  const startDate = formatTimeUTCToDaylightSaving(_data.startDate, tz);
  const endDate = formatTimeUTCToDaylightSaving(_data.endDate, tz);
  if (timeZoneId) {
    return `${startDate.format('LT')} - ${endDate.format('LT')} ${
      _data.timeZoneAbbr
    }`;
  }
  if (trainingId.startsWith('ATC')) {
    return '9:30 am - 11:30 am CST';
  }
  if (trainingId.startsWith('AC')) {
    return '10:00 am - 4:30 pm CST';
  }
  return '9:00 am - 6:00 pm CST';
}
